import { sessionTest } from "../api/session";
import { clearSession } from "../bandung";
import { redirect } from "react-router-dom";

const testSessionLoader = async (params) => {
  
  return null;
};

export { testSessionLoader };